// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"e09d85dc541a0ad3fa07","147":"9f5c31df93dab4b4b033","251":"5200d5bfbeac0fae44dd","352":"5f7ac03175393d944848","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};